import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Separator } from "@/components/ui/separator";
import type { NewsItem } from "@/lib/types";
import { fmtRelativeTime } from "@/lib/format";
import { useApi } from "@/hooks/useApi";
import { Newspaper, ExternalLink } from "lucide-react";

export function NewsFeed() {
  const { data, loading } = useApi<{ items: NewsItem[] }>("/api/news", 5 * 60_000);

  return (
    <Card className="flex h-full flex-col">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <Newspaper className="size-4" /> Nyheter
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1 overflow-y-auto pr-3" style={{ maxHeight: 520 }}>
        {loading && !data ? (
          <div className="space-y-3">
            {[0, 1, 2, 3].map((i) => (
              <Skeleton key={i} className="h-12" />
            ))}
          </div>
        ) : (
          <ul className="space-y-1">
            {data?.items.map((n, i) => (
              <li key={n.link}>
                {i > 0 && <Separator className="my-2" />}
                <a
                  href={n.link}
                  target="_blank"
                  rel="noreferrer"
                  className="group block rounded-md py-1 hover:bg-muted/50"
                >
                  <div className="flex items-start gap-1.5 text-sm font-medium leading-snug">
                    <span className="line-clamp-2">{n.title}</span>
                    <ExternalLink className="mt-0.5 size-3 shrink-0 opacity-0 transition-opacity group-hover:opacity-60" />
                  </div>
                  <div className="mt-1 text-xs text-muted-foreground">
                    {n.source}
                    {n.publishedAt ? ` · ${fmtRelativeTime(n.publishedAt)}` : ""}
                  </div>
                </a>
              </li>
            ))}
            {data?.items.length === 0 && <p className="text-sm text-muted-foreground">Inga nyheter hittades.</p>}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
